import { useAppSelector } from '@/redux'
import { useFirebase } from '@/utils'

export const useIsSocialLogin = () => {
  const loggedInWithLinkedin = useAppSelector(store => !!store.Session?.firebaseUserClaims?.linkedin_id)

  const firebase = useFirebase()
  const firebaseUser = firebase?.auth()?.currentUser

  const isSocialLogin =
    !!firebaseUser?.providerData?.some(provider => provider?.providerId !== 'password') || loggedInWithLinkedin

  return {
    isSocialLogin,
    firebaseUser,
  }
}
